import React, { useState } from 'react'
import "./Promo.css";
import { Col, Container, Row } from 'react-bootstrap'
import Event1img from '../../Images/event1.png'
import Event2img from '../../Images/event2.png'
import Event3img from '../../Images/event3.png'
import Event4img from '../../Images/event4.png'
import Event5img from '../../Images/event5.png'
import Event6img from '../../Images/event6.png'
import Clickcard from '../../Images/clickcard.png'
import WhatsappIcon from "./../../Images/whatsapp.png";
import EnquirePopup from '../EnquirePopup';

const EventsSection = () => {
    const [showPopup, setShowPopup] = useState(false);
    const handlePopup = () => {
        setShowPopup(true);
      };
      
      const closePopup = () => {
        setShowPopup(false);
      };
  return (
    <>

        <div className='bluestrip'>
            <h2><span>More Clients, More Business: </span> Expand your network and open doors to new opportunities.</h2>
            <h3><a style={{ cursor: "pointer" }} 
            onClick={handlePopup}
            >
            {/* <img src={WhatsappIcon} style={{width:"36px", height:"36px"}}/>  */}
            Boost Your Networking </a></h3>
        </div>
        <div className='eventroot'>
            <img src={Clickcard} className='clickcard'/>
            <Container fluid>
                <h2>Events...
                </h2>
                <Row >
                    <Col md={4} lg={2}>
                        <div className='eventbox1'>
                            <img src={Event1img}/>
                        </div>
                    </Col>
                    <Col md={4} lg={2}>
                        <div className='eventbox1'>
                            <img src={Event2img}/>
                        </div>
                    </Col>
                    <Col md={4} lg={2}>
                        <div className='eventbox1'>
                            <img src={Event3img}/>
                        </div>
                    </Col>
                    <Col md={4} lg={2}>
                        <div className='eventbox1'>
                            <img src={Event4img}/>
                        </div>
                    </Col>
                    <Col md={4} lg={2}>
                        <div className='eventbox1'>
                            <img src={Event5img}/>
                        </div>
                    </Col>
                    <Col md={4} lg={2}>
                        <div className='eventbox1'>
                            <img src={Event6img}/>
                        </div>
                    </Col>
                </Row>
            </Container>
            {showPopup && (
                           <EnquirePopup  open={showPopup} onClose={closePopup} setOpen={setShowPopup}/>
                          )}
        </div>
    </>
  )
}

export default EventsSection